import {Injectable} from '@angular/core';
import * as moment from 'moment-timezone';
import {environment} from 'src/environments/environment';
import {getLSUserInfo} from '../core/localStorage/ls-user-info';
// import {getLSUserInfo} from '../core/localStorage/ls-user-info';

@Injectable({
  providedIn: 'root',
})
export class TimezoneService {
  get timezone(): string {
    const userInfo = getLSUserInfo();
    return userInfo?.timezone || moment.tz.guess() || environment.timezone || 'America/New_York';
  }

  convertUtcToTimezone(timeStamp: string, timestampFormat?: string): string {
    return moment(timeStamp)
      .tz(this.timezone)
      .format(timestampFormat || 'hh:mma');
  }

  convertDateToUtcString(date: Date): string {
    return moment(date).utc().format();
  }

  convertMomentToUtcString(date: moment.Moment): string {
    return date.clone().utc().format();
  }

  isDateToday(date: string): boolean {
    return moment.tz(date, this.timezone).isSame(this.now, 'day');
  }

  areDatesWithinRange(startDate: string, endDate: string): boolean {
    const startMoment = moment.tz(startDate, this.timezone);
    const endMoment = moment.tz(endDate, this.timezone);
    return this.now.isBetween(startMoment, endMoment, 'day', '[]');
  }

  getTimeZone(): string {
    return this.timezone;
  }

  getTimeZoneAbbr(): string {
    return moment.tz(this.timezone).zoneAbbr();
  }

  isDateExpired(date: string): boolean {
    return moment.tz(date, this.timezone).isBefore(this.now, 'day');
  }

  getDaysUntilExpiration(date: string): number {
    const targetDate = moment.tz(date, this.timezone).endOf('day');
    const diffInDays = targetDate.diff(this.now, 'days');
    return diffInDays > 0 ? diffInDays : 0; // Return 0 if date is in the past
  }

  get now() {
    return moment().tz(this.timezone).startOf('day');
  }
}
